import Layout from '../UI/Layout/Layout'
import '../UI/LegalDocumentStyling/LegalDocument.scss'

const Imprint = () => {
  return <Layout>imprint</Layout>
}

export default Imprint
